





























import { Component, Prop, Vue } from "vue-property-decorator";
@Component({})
export default class TextField extends Vue {
  @Prop({ required: true }) label!: string;
  @Prop({ default: true }) required!: boolean;
  @Prop({ default: false }) textarea!: boolean;
  @Prop({}) value!: string;
  @Prop({ default: 50 }) max!: number;
  @Prop({}) min!: number;
  @Prop({ default: "12" }) md!: string;
  @Prop({
    validator: (value: string) => {
      if (!value) return true;
      const allowedTypes = ["text", "number", "email", "iban"];
      return allowedTypes.includes(value);
    }
  })
  type!: string;

  // Eğer IBAN tipinde ise, prefix "TR" gösterimi
  get prefix(): string {
    return this.type === "iban" ? "TR" : "";
  }

  rules: Array<(v: any) => boolean | string> = [];

  updateValue(value: string): void {
    if (this.type === "iban") {
      // Kullanıcının girdiği değerden "TR" kaldırılıyor,
      // sadece sayısal kısım elde ediliyor.
      let cleanValue = value.replace(/^TR/, "");
      cleanValue = cleanValue.replace(/[^0-9]/g, "");
      // Sayısal kısım 24 haneye sınırlandırılıyor (TR eklenince toplam 26 karakter)
      cleanValue = cleanValue.slice(0, 24);
      this.$emit("input", cleanValue);
    } else {
      this.$emit("input", value);
    }
  }

  private setupValidationRules(): void {
    // Zorunluluk kontrolü
    if (this.required) {
      this.rules.push((v: any) => !!v || "Zorunlu alan");
    }

    // Minimum karakter kontrolü
    if (this.min != null) {
      this.rules.push(
          (v: string) =>
              ((v || "").length >= this.min) || `Minimum ${this.min} karakter`
      );
    }

    // Maksimum karakter kontrolü
    if (this.max != null) {
      this.rules.push(
          (v: string) =>
              ((v || "").length <= this.max) || `Maksimum ${this.max} karakter`
      );
    }

    // Tip bazlı özel kontroller
    const typeValidations: Record<string, (v: string) => boolean | string> = {
      email: (v: string) => {
        const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return pattern.test(v) || "Geçerli bir e-posta adresi giriniz";
      },
      number: (v: string) => {
        if (!v) return true;
        // Sadece rakamlardan oluşması kontrol ediliyor
        return /^[0-9]+$/.test(v) || "Sadece 0-9 arası rakam girebilirsiniz";
      },
      iban: (v: string) => {
        if (!v) return true;
        // Artık v-model'de sadece sayısal kısım saklanıyor; 24 hane olmalı.
        return /^[0-9]{24}$/.test(v) || "Geçerli bir IBAN giriniz (24 hane)";
      }
    };

    if (this.type && typeValidations[this.type]) {
      this.rules.push(typeValidations[this.type]);
    }
  }

  created() {
    this.setupValidationRules();
  }
}
